/* =====================================================================
   HER ADAA THEME — vanilla JS, no dependencies
   1. Helpers   2. Drawers & modals   3. Cart (AJAX API) + bundle bar
   4. Quick add 5. Product page       6. Wishlist   7. Search
   8. Collection filters   9. Misc (pincode, track, recs)
   ===================================================================== */
(function () {
  'use strict';
  const HA = window.HA || { tiers: [], routes: {} };
  const TIERS = (HA.tiers || []).filter(t => t && t.minQty > 0).sort((a, b) => a.minQty - b.minQty);
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = cents => '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;
  const ICON = {
    close: '<path d="M6 6l12 12M18 6L6 18"/>', plus: '<path d="M12 5v14M5 12h14"/>', minus: '<path d="M5 12h14"/>',
    tag: '<path d="M3.5 12.5V4.5h8l9 9-8 8z"/><circle cx="8" cy="9" r="1.3"/>', check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>'
  };
  const icon = n => `<svg class="i" viewBox="0 0 24 24" aria-hidden="true">${ICON[n] || ''}</svg>`;
  let toastT;
  const toast = msg => { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('show'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('show'), 2400); };
  const store = {
    get(k, d) { try { const v = localStorage.getItem('heradaa:' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem('heradaa:' + k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- 2. Drawers & modals ---------- */
  let lastFocus = null;
  function openPanel(el) {
    if (!el) return;
    closeAll(false);
    lastFocus = document.activeElement;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
    if (el.id === 'menu-drawer') { document.body.classList.add('menu-open'); $$('[data-open="menu-drawer"]').forEach(b => b.setAttribute('aria-expanded', 'true')); }
    const ov = $('#overlay'); ov.hidden = false; requestAnimationFrame(() => ov.classList.add('show'));
    document.body.classList.add('no-scroll');
    setTimeout(() => { const f = el.querySelector('input:not([type=hidden]), button, a[href]'); f && f.focus(); }, 60);
  }
  function closeAll(restore = true) {
    $$('.drawer.open, .search-panel.open, .filters.open').forEach(el => { el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); });
    const ov = $('#overlay'); if (ov) { ov.classList.remove('show'); setTimeout(() => { if (!ov.classList.contains('show')) ov.hidden = true; }, 250); }
    document.body.classList.remove('no-scroll');
    setTimeout(() => { if (!$('#menu-drawer.open')) document.body.classList.remove('menu-open'); }, 300);
    $$('[data-open="menu-drawer"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (restore && lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }

  /* ---------- 3. Cart ---------- */
  function bundleMessage(count, subtotal) {
    if (!TIERS.length) return '';
    let tier = null; TIERS.forEach(t => { if (count >= t.minQty) tier = t; });
    const next = TIERS.find(t => t.minQty > count);
    if (!tier) { const n = next.minQty - count; return `Add ${plural(n, 'more item')} to get ${next.percent}% off`; }
    if (next) return `${tier.percent}% off applied! Add ${next.minQty - count} more to get ${next.percent}% off`;
    return `${tier.percent}% off applied, you're saving ${money(subtotal * tier.percent / 100)}`;
  }
  function bundleBar(count, subtotal) {
    if (!TIERS.length || !count) return '';
    const maxQ = TIERS[TIERS.length - 1].minQty;
    const done = count >= maxQ;
    const ticks = TIERS.map(t => `<span class="tick ${count >= t.minQty ? 'hit' : ''}" style="left:${t.minQty / maxQ * 100}%"></span>`).join('');
    const labels = TIERS.map(t => `<span style="left:${t.minQty / maxQ * 100}%">${t.minQty} items · ${t.percent}%</span>`).join('');
    return `<div class="bundle-bar ${done ? 'done' : ''}"><p aria-live="polite">${icon(done ? 'check' : 'tag')}${bundleMessage(count, subtotal)}</p>
      <div class="progress" role="progressbar" aria-valuemin="0" aria-valuemax="${maxQ}" aria-valuenow="${Math.min(count, maxQ)}" aria-label="Items towards bundle offer"><i style="width:${Math.min(100, count / maxQ * 100)}%"></i>${ticks}</div>
      <div class="progress-labels" aria-hidden="true">${labels}</div></div>`;
  }
  function nudgeText(extra = 0) {
    const c = cartCount + extra; const next = TIERS.find(t => t.minQty > c);
    return next ? `Add ${next.minQty - c} more to unlock ${next.percent}% off` : 'Bundle offer unlocked — mix & match freely';
  }
  let cartCount = Number($('[data-cart-count]')?.dataset.count || 0);

  async function fetchCart() { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  function updateCount(n) {
    cartCount = n;
    $$('[data-cart-count]').forEach(b => { b.textContent = n; b.dataset.count = n; });
    const btn = $('[data-open="cart-drawer"]'); if (btn) btn.setAttribute('aria-label', `Shopping bag, ${plural(n, 'item')}`);
    $$('[data-bundle-nudge]').forEach(el => { el.textContent = nudgeText(Number(el.dataset.bundleNudge || 0)); });
  }
  function renderDrawer(cart) {
    const body = $('[data-cart-body]'), foot = $('[data-cart-foot]'); if (!body) return;
    updateCount(cart.item_count);
    $('[data-cart-count-label]').textContent = cart.item_count ? `(${cart.item_count})` : '';
    if (!cart.item_count) { body.innerHTML = $('[data-empty-cart]').innerHTML; foot.hidden = true; return; }
    body.innerHTML = bundleBar(cart.item_count, cart.items_subtotal_price) + cart.items.map(it => {
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      const size = it.variant_title && it.variant_title !== 'Default Title' ? `Size ${esc(it.variant_title)} · ` : '';
      return `<div class="line-item">
        <a href="${it.url}">${img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=200" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
        <div>
          <div class="li-top"><a class="li-title" href="${it.url}">${esc(it.product_title)}</a></div>
          <div class="li-meta">${size}${money(it.final_price)}</div>
          <div class="li-bottom">
            <div class="qty sm" role="group" aria-label="Quantity for ${esc(it.product_title)}">
              <button type="button" data-line-change="${it.key}" data-qty="${it.quantity - 1}" aria-label="Decrease quantity">${icon('minus')}</button>
              <span>${it.quantity}</span>
              <button type="button" data-line-change="${it.key}" data-qty="${it.quantity + 1}" aria-label="Increase quantity">${icon('plus')}</button>
            </div>
            <span class="li-price">${money(it.final_line_price)}</span>
          </div>
          <button type="button" class="remove-btn" data-line-change="${it.key}" data-qty="0">Remove</button>
        </div></div>`;
    }).join('');
    body.insertAdjacentHTML('beforeend', '<div class="cart-upsell in-drawer" data-cart-upsell hidden></div>');
    renderUpsell($('[data-cart-upsell]', body), cart.items.map(i => i.product_id));
    const discounts = (cart.cart_level_discount_applications || []).map(d => `<div class="row discount"><span>${esc(d.title)}</span><span>−${money(d.total_allocated_amount)}</span></div>`).join('');
    $('[data-cart-summary]').innerHTML = `<div class="summary-lines">
      <div class="row"><span>Subtotal (${plural(cart.item_count, 'item')})</span><span>${money(cart.items_subtotal_price)}</span></div>
      ${discounts}
      <div class="row total"><span>Total</span><span>${money(cart.total_price)}</span></div>
      <div class="note">Shipping calculated at checkout · Bundle offer applied automatically</div></div>`;
    $('[data-checkout-btn]').textContent = `Checkout · ${money(cart.total_price)}`;
    foot.hidden = false;
  }
  async function openCart() { openPanel($('#cart-drawer')); renderDrawer(await fetchCart()); }
  async function addToCart(id, qty = 1, open = true) {
    const r = await fetch(HA.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); toast(e.description || 'Sorry, that size could not be added.'); return false; }
    document.dispatchEvent(new CustomEvent('ha:cart-updated'));
    if (open) await openCart(); else updateCount((await fetchCart()).item_count);
    return true;
  }
  async function changeLine(key, qty) {
    const r = await fetch(HA.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) });
    const cart = await r.json();
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    renderDrawer(cart);
  }
  // Server-rendered bundle bar on the cart page
  $$('[data-bundle-bar]').forEach(el => { el.innerHTML = bundleBar(Number(el.dataset.count), Number(el.dataset.subtotal)); });
  $$('[data-bundle-nudge]').forEach(el => { el.textContent = nudgeText(Number(el.dataset.bundleNudge || 0)); });


  /* ---------- 3b. Cart upsell (drawer + cart page) ---------- */
  const UP = HA.upsell;
  const upCache = {};
  const upFetch = url => (upCache[url] = upCache[url] || fetch(url).then(r => r.ok ? r.text() : '').catch(() => ''));
  async function renderUpsell(el, productIds) {
    if (!el) return;
    if (!UP) { el.hidden = true; return; }
    const inCart = new Set(productIds.map(String));
    const urls = [];
    if (UP.source === 'related' && productIds.length) urls.push(`${HA.routes.recs}?section_id=cart-upsell&product_id=${productIds[productIds.length - 1]}&limit=10&intent=related`);
    urls.push(`${HA.routes.root.replace(/\/$/, '')}/?section_id=cart-upsell`);
    const seen = new Set(), cards = [];
    for (const u of urls) {
      if (cards.length >= UP.limit) break;
      const d = document.createElement('div'); d.innerHTML = await upFetch(u);
      d.querySelectorAll('[data-upsell-card]').forEach(c => {
        const id = c.dataset.productId;
        if (cards.length < UP.limit && !inCart.has(id) && !seen.has(id)) { seen.add(id); cards.push(c.outerHTML); }
      });
    }
    if (!cards.length) { el.hidden = true; el.innerHTML = ''; return; }
    const next = TIERS.find(t => t.minQty > cartCount);
    const sub = UP.nudge && next ? `${icon('tag')}Add ${plural(next.minQty - cartCount, 'more item')} to get ${next.percent}% off` : esc(UP.text || '');
    el.innerHTML = `<div class="upsell-head"><h3>${esc(UP.heading || 'You may also like')}</h3>${sub ? `<p>${sub}</p>` : ''}</div><div class="upsell-track">${cards.join('')}</div>`;
    el.hidden = false;
  }
  $$('[data-cart-upsell][data-pids]').forEach(el => { try { renderUpsell(el, JSON.parse(el.dataset.pids)); } catch (e) {} });

  /* ---------- 4. Quick add ---------- */
  function closeQuickAdd(refocus) {
    $$('.qa-panel:not([hidden])').forEach(p => { p.hidden = true; const b = p.parentElement.querySelector('[data-quick-open]'); if (b) { b.hidden = false; b.setAttribute('aria-expanded', 'false'); if (refocus) b.focus(); } });
  }

  /* ---------- 5. Product page ---------- */
  const pdpForm = $('#pdp-form');
  let pdpQty = 1, pdpMax = 10;
  function selectedVariant() { return $('[data-variant-input]', pdpForm)?.value; }
  function pickSize(btn) {
    $$('#size-chips .size-chip').forEach(b => b.setAttribute('aria-pressed', b === btn));
    $('[data-variant-input]', pdpForm).value = btn.dataset.variant;
    const sl = $('#size-label'); if (sl) sl.textContent = `${$('#size-chips').dataset.label || 'Select size'}: ${btn.dataset.size}`;
    $$('[data-price-display]').forEach(p => { if (btn.dataset.priceHtml) p.innerHTML = btn.dataset.priceHtml; else p.textContent = btn.dataset.price; });
    const left = Number(btn.dataset.stock); const msg = $('#size-msg') || document.createElement('p');
    const low = left > 0 && left <= (HA.lowStock || 3);
    msg.className = 'size-msg' + (low ? ' low' : '');
    msg.textContent = low ? `Only ${left} left in size ${btn.dataset.size}` : 'In stock · ready to ship';
    const s = $('#s-size'); if (s) s.textContent = ' · Size ' + btn.dataset.size;
    pdpMax = Math.min(10, left || 10);
    if (pdpQty > pdpMax) setQty(pdpMax);
  }
  function setQty(n) { pdpQty = Math.max(1, Math.min(pdpMax, n)); const o = $('#pdp-qty'); if (o) o.textContent = pdpQty; const q = $('[data-qty-input]'); if (q) q.value = pdpQty; }
  function requireSize() {
    if (selectedVariant()) return true;
    const msg = $('#size-msg'); if (msg) { msg.className = 'size-msg err'; msg.textContent = 'Please select your size to continue'; }
    const chips = $('#size-chips'); if (chips) { chips.scrollIntoView({ behavior: 'smooth', block: 'center' }); const f = chips.querySelector('.size-chip:not([disabled])'); f && setTimeout(() => f.focus({ preventScroll: true }), 300); }
    return false;
  }
  if (pdpForm) {
    pdpForm.addEventListener('submit', async e => {
      e.preventDefault(); if (!requireSize()) return;
      const btn = $('[data-add-btn]'); btn && btn.classList.add('is-loading');
      await addToCart(selectedVariant(), pdpQty); btn && btn.classList.remove('is-loading');
    });
    const track = $('#gallery-track');
    track && track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      $$('.dots span').forEach((d, j) => d.classList.toggle('on', j === i));
      $$('.thumbs button').forEach((b, j) => b.setAttribute('aria-current', j === i));
    }, { passive: true });
    const bar = $('#sticky-atc'), row = $('#atc-row');
    if (bar && row && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => { const show = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('show', show); bar.setAttribute('aria-hidden', !show); }).observe(row);
    }
  }


  /* ---------- 5b. Estimated delivery (working days, Sundays skipped) ---------- */
  $$('[data-eta]').forEach(el => {
    const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) k++; } return d; };
    const f = d => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    const a = add(Number(el.dataset.min || 3)), b = add(Number(el.dataset.max || 6));
    const out = $('[data-eta-range]', el); if (out) out.textContent = `${f(a)} – ${f(b)}`;
  });

  /* ---------- 6. Wishlist (saved in this browser) ---------- */
  let wishlist = store.get('wishlist', []);
  function syncWish() {
    $$('[data-wish]').forEach(b => { const on = wishlist.includes(b.dataset.wish); b.setAttribute('aria-pressed', on); b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist'); });
    $$('[data-wish-count]').forEach(b => { b.textContent = wishlist.length; b.dataset.count = wishlist.length; });
  }
  function toggleWish(handle) {
    const on = !wishlist.includes(handle);
    wishlist = on ? [...wishlist, handle] : wishlist.filter(h => h !== handle);
    store.set('wishlist', wishlist); syncWish(); toast(on ? 'Saved to your wishlist' : 'Removed from wishlist');
    if ($('[data-wishlist-grid]')) renderWishlist();
  }
  async function renderWishlist() {
    const grid = $('[data-wishlist-grid]'); if (!grid) return;
    const lead = $('[data-wish-lead]'), empty = $('[data-wishlist-empty]');
    if (!wishlist.length) { grid.innerHTML = ''; empty.hidden = false; lead.textContent = 'Tap the heart on any style to save it here.'; return; }
    empty.hidden = true; lead.textContent = `${plural(wishlist.length, 'piece')} saved for later. Tap “Move to bag” and pick your size.`;
    const products = (await Promise.all(wishlist.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))).filter(Boolean);
    grid.innerHTML = products.map(p => {
      const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=720' : '';
      return `<article class="card" data-card data-wish-card="${p.handle}">
        <div class="card-media"><a class="card-link" href="/products/${p.handle}" aria-label="${esc(p.title)}">${img ? `<img class="img-1" src="${img}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
          <button type="button" class="icon-btn wish-btn" data-wish="${p.handle}" aria-pressed="true" aria-label="Remove from wishlist"><svg class="i" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.1a4.3 4.3 0 0 1 7.5 2.7C19.5 15.4 12 20 12 20z"/></svg></button>
          ${p.available ? `<button type="button" class="quick-add" data-quick-open aria-expanded="false">Move to bag ${icon('plus')}</button>
          <div class="qa-panel" hidden role="group" aria-label="Choose a size"><div class="qa-top"><span>Select size</span><button type="button" data-quick-close aria-label="Close">${icon('close')}</button></div>
          <div class="qa-sizes">${p.variants.map(v => `<button type="button" data-quick-add="${v.id}" ${v.available ? '' : 'disabled'}>${esc(v.title)}</button>`).join('')}</div></div>` : '<span class="card-badge">Sold out</span>'}
        </div>
        <div class="card-body"><a class="card-title" href="/products/${p.handle}">${esc(p.title)}</a><div class="price">${money(p.price)}</div></div></article>`;
    }).join('');
    syncWish();
  }

  /* ---------- 7. Predictive search ---------- */
  let searchT;
  const searchInput = $('#search-input'), searchBox = $('#search-results');
  const searchDefault = searchBox ? searchBox.innerHTML : '';
  searchInput && searchInput.addEventListener('input', () => {
    clearTimeout(searchT);
    const q = searchInput.value.trim();
    if (!q) { searchBox.innerHTML = searchDefault; return; }
    searchT = setTimeout(async () => {
      try {
        const r = await fetch(`${HA.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const data = await r.json(); const items = data.resources?.results?.products || [];
        searchBox.innerHTML = items.length
          ? items.map(p => `<a class="search-item" href="${p.url}">${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy">` : ''}<span><span style="display:block">${esc(p.title)}</span><strong>${money(Number(p.price) * 100)}</strong></span></a>`).join('')
            + `<a class="btn btn-outline" style="margin-top:12px" href="${HA.routes.search}?q=${encodeURIComponent(q)}&type=product">View all results</a>`
          : `<p>No results for “${esc(q)}”. Try “co-ord”, “cotton” or a colour like “pink”.</p>`;
      } catch (e) { /* network issue: keep defaults */ }
    }, 200);
  });

  /* ---------- 8. Collection filters & sort ---------- */
  const filterForm = $('#filter-form');
  const isDesktop = () => window.matchMedia('(min-width:900px)').matches;
  function submitFilters() {
    const params = new URLSearchParams(new FormData(filterForm));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    location.search = params.toString();
  }
  filterForm && filterForm.addEventListener('change', () => { if (isDesktop()) submitFilters(); });
  filterForm && filterForm.addEventListener('submit', e => { e.preventDefault(); submitFilters(); });
  const sortSel = $('[data-sort]');
  sortSel && sortSel.addEventListener('change', () => { if (filterForm) { filterForm.elements.sort_by.value = sortSel.value; submitFilters(); } else { const p = new URLSearchParams(location.search); p.set('sort_by', sortSel.value); location.search = p.toString(); } });

  /* ---------- 9. Recommendations ---------- */
  $$('[data-recs]').forEach(async el => {
    if (el.children.length) return;
    try { const html = await (await fetch(el.dataset.url)).text(); const d = document.createElement('div'); d.innerHTML = html; const inner = d.querySelector('[data-recs]'); if (inner) { el.innerHTML = inner.innerHTML; syncWish(); updateCount(cartCount); } } catch (e) {}
  });


  /* ---------- 9b. Recently viewed (saved in this browser) ---------- */
  let recent = store.get('recent', []);
  if (HA.product) { recent = [HA.product, ...recent.filter(h => h !== HA.product)].slice(0, 16); store.set('recent', recent); }
  const cardCache = {};
  async function renderRecent() {
    for (const sec of $$('[data-recently-viewed]')) {
      const list = $('[data-recent-list]', sec);
      const handles = recent.filter(h => h !== sec.dataset.exclude).slice(0, Number(sec.dataset.limit || 8));
      if (!handles.length) { sec.hidden = true; list.innerHTML = ''; continue; }
      const html = await Promise.all(handles.map(h => (cardCache[h] = cardCache[h] || fetch(`/products/${encodeURIComponent(h)}?view=card`).then(r => r.ok ? r.text() : '').catch(() => ''))));
      const cards = html.filter(x => x.includes('data-card'));
      if (!cards.length) { sec.hidden = true; continue; }
      list.innerHTML = cards.join('');
      sec.hidden = false; syncWish();
    }
  }
  renderRecent();

  /* ---------- Delegated events ---------- */
  document.addEventListener('click', e => {
    const t = e.target;
    if (!t.closest('.card-media')) closeQuickAdd();
    let el;
    if ((el = t.closest('[data-open]'))) {
      e.preventDefault();
      const id = el.dataset.open;
      if (id === 'cart-drawer') openCart(); else openPanel(document.getElementById(id));
      if (id === 'search-panel') setTimeout(() => searchInput && searchInput.focus(), 80);
      return;
    }
    if (t.closest('[data-close]') || t.id === 'overlay') { closeAll(); return; }
    if ((el = t.closest('[data-close-modal]'))) { el.closest('dialog').close(); return; }
    if ((el = t.closest('[data-wish]'))) { e.preventDefault(); toggleWish(el.dataset.wish); return; }
    if ((el = t.closest('[data-quick-open]'))) {
      const panel = el.parentElement.querySelector('.qa-panel'); closeQuickAdd();
      panel.hidden = false; el.hidden = true; el.setAttribute('aria-expanded', 'true');
      const f = panel.querySelector('[data-quick-add]:not([disabled])'); f && f.focus(); return;
    }
    if (t.closest('[data-quick-close]')) { closeQuickAdd(true); return; }
    if ((el = t.closest('[data-quick-add]'))) {
      const wishCard = el.closest('[data-wish-card]');
      addToCart(el.dataset.quickAdd, 1).then(ok => { if (ok && wishCard) { wishlist = wishlist.filter(h => h !== wishCard.dataset.wishCard); store.set('wishlist', wishlist); syncWish(); renderWishlist(); } });
      closeQuickAdd(); return;
    }
    if (t.closest('[data-recent-clear]')) { recent = HA.product ? [HA.product] : []; store.set('recent', recent); renderRecent(); return; }
    if ((el = t.closest('[data-upsell-add]'))) {
      const card = el.closest('[data-upsell-card]'); const sel = card && card.querySelector('[data-upsell-size]');
      const id = el.dataset.variant || (sel && sel.value);
      if (!id) { if (sel) { sel.classList.add('invalid'); sel.focus(); } toast('Please choose a size first'); return; }
      el.classList.add('is-loading');
      if (document.body.classList.contains('template-cart')) addToCart(id, 1, false).then(ok => { if (ok) location.reload(); else el.classList.remove('is-loading'); });
      else addToCart(id, 1, true).then(ok => { if (!ok) el.classList.remove('is-loading'); });
      return;
    }
    if ((el = t.closest('[data-line-change]'))) { e.preventDefault(); changeLine(el.dataset.lineChange, Number(el.dataset.qty)); return; }
    if ((el = t.closest('.size-chip'))) { if (!el.disabled) pickSize(el); return; }
    if ((el = t.closest('[data-qty-step]'))) { setQty(pdpQty + Number(el.dataset.qtyStep)); return; }
    if (t.closest('[data-sticky-add]')) { pdpForm && pdpForm.requestSubmit(); return; }
    if (t.closest('[data-buy-now]')) {
      if (!requireSize()) return;
      addToCart(selectedVariant(), pdpQty, false); return;
    }
    if (t.closest('[data-size-guide]')) { $('#size-modal').showModal(); return; }
    if ((el = t.closest('[data-zoom]'))) { const m = $('#zoom-modal'); $('[data-zoom-img]', m).src = el.dataset.zoom; $('[data-zoom-img]', m).alt = el.dataset.alt; $('[data-zoom-title]', m).textContent = el.dataset.alt; m.showModal(); return; }
    if ((el = t.closest('[data-thumb]'))) { const tr = $('#gallery-track'); tr.scrollTo({ left: Number(el.dataset.thumb) * tr.clientWidth, behavior: 'smooth' }); return; }
    // links inside drawers close them
    if (t.closest('a[href]') && t.closest('.drawer, .search-panel, .filters')) closeAll(false);
  });

  document.addEventListener('submit', e => {
    const f = e.target;
    if (f.matches('[data-pincode]')) {
      e.preventDefault(); const pin = f.elements.pin.value.trim(); const out = $('#pin-result');
      if (/^[1-9]\d{5}$/.test(pin)) {
        const d = new Date(); d.setDate(d.getDate() + Number(f.dataset.days || HA.deliveryDays || 4)); const sfx = f.dataset.suffix;
        out.className = 'pin-result ok'; out.textContent = `Delivery by ${d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' })}${sfx ? ' · ' + sfx : ''}`;
      } else { out.className = 'pin-result err'; out.textContent = 'Please enter a valid 6-digit pincode.'; }
    }
    if (f.matches('[data-track-form]')) {
      e.preventDefault();
      const id = f.elements.id, c = f.elements.contact;
      id.closest('.field').classList.toggle('invalid', !id.value.trim());
      c.closest('.field').classList.toggle('invalid', c.value.trim().length < 5);
      if (!id.value.trim() || c.value.trim().length < 5) return;
      const res = $('[data-track-result]'); res.hidden = false;
      const wa = $('[data-track-wa]'); if (wa) wa.href = wa.href.split('?')[0] + '?text=' + encodeURIComponent(`Hi! Please share the status of my order ${id.value.trim()}.`);
      res.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
  document.addEventListener('input', e => {
    const t = e.target;
    if (t.matches('[data-upsell-size]')) t.classList.remove('invalid');
    if (t.matches('[inputmode="numeric"]:not([type="number"])')) t.value = t.value.replace(/\D/g, '');
    const fld = t.closest('.field.invalid'); if (fld) fld.classList.remove('invalid');
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeQuickAdd(true); closeAll(); } });
  window.addEventListener('storage', e => { if (e.key === 'heradaa:wishlist') { wishlist = store.get('wishlist', []); syncWish(); renderWishlist(); } });
  window.addEventListener('pageshow', e => { if (e.persisted) fetchCart().then(c => updateCount(c.item_count)); });

  syncWish();
  renderWishlist();
})();
